import { Button, DatePicker, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import {
  ErrorToast,
  ShowInputError,
  SuccessToast,
} from "../../../widgets/AppToast";
import useUserData from "../../../hooks/useUserData";
import moment from "moment";
import dayjs from "dayjs";

function EditDeckLog() {
  const { id } = useParams();
  const user = useUserData();
  const [loader, set_loader] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [sea_condition, set_sea_condition] = useState("");
  const [wind_condition, set_wind_condition] = useState([]);
  const [swell, set_swell] = useState("");
  const [position_in_latitude, set_position_in_latitude] = useState("");
  const [position_in_longitude, set_position_in_longitude] = useState("");
  const [speed, set_speed] = useState("");
  const [speed_on_ground, set_speed_on_ground] = useState("");
  const [distance_covered, set_distance_covered] = useState("");
  const [voyage_qty_of_cargo, set_voyage_qty_of_cargo] = useState("");
  const [qty_of_ballast, set_qty_of_ballast] = useState("");
  const [port_from, set_port_from] = useState("");
  const [port_to, set_port_to] = useState("");
  const [instructed_speed, set_instructed_speed] = useState("");
  const [loaded_ballast, set_loaded_ballast] = useState("");
  const [draft, set_draft] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [course_heading, set_course_heading] = useState("");
  const [distance_to_go, set_Distance_To_Go] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [hours_Underway, set_Hours_Underway] = useState("");
  const [hsfo_consumption, set_hsfo_consumption] = useState("");
  const [vlsfo_consumption, set_vlsfo_consumption] = useState("");
  const [lsmgo_consumption, set_lsmgo_consumption] = useState("");
  const [other_consumption, set_other_consumption] = useState("");
  const [vessel_status, set_vessel_status] = useState("");
  const [lo_consumption, set_lo_consumption] = useState("");
  const [fw_consumption, set_fw_consumption] = useState("");
  const [swell_direction, set_swell_direction] = useState("");
  const [visibility, set_visibility] = useState("");

  const Edit_DECK_LOGBOOK_APIS = async (save_submit) => {
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("save_submit", Number(save_submit) || 0);
    FORM_DATA.append("deck_log_id", atob(id) || "");
    FORM_DATA.append("update", "true");
    FORM_DATA.append("sea_condition", sea_condition || "");
    FORM_DATA.append(
      "voyage_id",
      staff_dashboard?.voyage_details?.[0]?.id || ""
    );
    FORM_DATA.append("wind_condition", wind_condition || "");
    FORM_DATA.append("swell", swell || "");
    FORM_DATA.append("latitude", position_in_latitude || "");
    FORM_DATA.append("longitude", position_in_longitude || "");
    FORM_DATA.append("speed_gps", Number(speed) || 0);
    FORM_DATA.append("speed_through_water", Number(speed_on_ground) || 0);
    FORM_DATA.append("distance_covered", Number(distance_covered) || 0);
    FORM_DATA.append("distance_to_go", Number(distance_to_go) || 0);
    FORM_DATA.append("course", Number(course_heading) || 0);
    FORM_DATA.append("hours_underway", hours_Underway);
    FORM_DATA.append("vlsfo_consumption", vlsfo_consumption || 0);
    FORM_DATA.append("lsmgo_consumption", lsmgo_consumption || 0);
    FORM_DATA.append("other_consumption", other_consumption || 0);
    FORM_DATA.append("hsfo_consumption", hsfo_consumption || 0);
    FORM_DATA.append("voyage_type", loaded_ballast || "");
    FORM_DATA.append("draft", Number(draft) || 0);
    FORM_DATA.append("qty_of_cargo", Number(voyage_qty_of_cargo) || 0);
    FORM_DATA.append("qty_of_ballast", Number(qty_of_ballast) || 0);
    FORM_DATA.append("port_from", port_from || "");
    FORM_DATA.append("port_to", port_to || "");
    FORM_DATA.append("instructed_speed", Number(instructed_speed) || 0);
    FORM_DATA.append("deck_comment", free_Text || "");
    FORM_DATA.append("log_date_time", logDate || "");
    FORM_DATA.append("vessel_status", vessel_status || "");
    FORM_DATA.append("lube_orb", lo_consumption || "");
    FORM_DATA.append("fw_rob", fw_consumption || "");
    FORM_DATA.append("swell_direction", swell_direction || "");
    FORM_DATA.append("visibility", visibility || "");
    post(ApiURL.view_or_update_deck_log, FORM_DATA).then((res) => {
      if (res?.status === true) {
        set_loader(false);
        SuccessToast(
          "Congratulation!!",
          "Decklogbook Details Successfully Updated!!"
        );
        VIEW_DECK_LOGBOOK_APIS();
      } else {
        set_loader(false);
        const errors = res?.errors || {};
        set_errors(errors);
        ErrorToast(
          "Error message",
          "Submission failed! Please fill in all required fields and try again."
        );
      }
    });
  };

  const VIEW_DECK_LOGBOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("deck_log_id", atob(id));
    post(ApiURL.view_or_update_deck_log, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const deck_Data = res?.deck_log_data;
        set_sea_condition(deck_Data?.sea_condition);
        set_wind_condition(deck_Data?.wind_condition);
        set_swell(deck_Data?.swell);
        set_position_in_latitude(deck_Data?.latitude);
        set_position_in_longitude(deck_Data?.longitude);
        set_speed(deck_Data?.speed_gps);
        set_speed_on_ground(deck_Data?.speed_through_water);
        set_distance_covered(deck_Data?.distance_covered);
        set_Distance_To_Go(deck_Data?.distance_to_go);
        set_voyage_qty_of_cargo(deck_Data?.qty_of_cargo);
        set_qty_of_ballast(deck_Data?.qty_of_ballast);
        set_port_from(deck_Data?.port_from);
        set_port_to(deck_Data?.port_to);
        set_instructed_speed(deck_Data?.instructed_speed);
        set_loaded_ballast(deck_Data?.voyage_type);
        set_draft(deck_Data?.draft);
        set_Free_Text(deck_Data?.deck_comment);
        set_course_heading(deck_Data?.course);
        set_LogDate(deck_Data?.log_date_time);
        set_Hours_Underway(deck_Data?.hours_underway);
        set_vlsfo_consumption(deck_Data?.vlsfo_consumption);
        set_lsmgo_consumption(deck_Data?.lsmgo_consumption);
        set_hsfo_consumption(deck_Data?.hsfo_consumption);
        set_other_consumption(deck_Data?.other_consumption);
        setSubmitStatus(res?.submit_status);
        set_vessel_status(deck_Data?.vessel_status);
        set_lo_consumption(deck_Data?.lube_orb);
        set_fw_consumption(deck_Data?.fw_rob);
        set_swell_direction(deck_Data?.swell_direction);
        set_visibility(deck_Data?.visibility);
      } else {
        ErrorToast("Error message", res?.message);
      }
    });
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    VIEW_DECK_LOGBOOK_APIS();
  }, []);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const wind_conditions = [
    "0 Beaufort - Calm",
    "1 Beaufort - Light Air",
    "2 Beaufort - Light Breeze",
    "3 Beaufort - Gentle Breeze",
    "4 Beaufort - Moderate Breeze",
    "5 Beaufort - Fresh Breeze",
    "6 Beaufort - Strong Breeze",
    "7 Beaufort - Near Gale",
    "8 Beaufort - Gale",
    "9 Beaufort - Strong Gale",
    "10 Beaufort - Storm",
    "11 Beaufort - Violent Storm",
    "12 Beaufort - Hurricane",
  ];

  const weather_details = [
    "Calm (glassy) - (0 – 0)m height",
    "Calm (rippled) - 0 – 0.10m height",
    "Smooth (wavelets) - 0.10 – 0.50m height",
    "Slight - 0.50 – 1.25m height",
    "Moderate - 1.25 – 2.50m height",
    "Rough - 2.50 – 4.00m height",
    "Very Rough - 4.00 – 6.00m height",
    "High - 6.00 – 9.00m height",
    "Very High - 9.00 – 14.00m height",
    "Phenomenal - 14m height",
  ];

  const visibility_Data = [
    "0 - Less than 50 m (less than 55 yd.)",
    "1 - 50 m but less than 200 m",
    "2 - 200 m but less than 500 m",
    "3 - 500 m but less than 1 km",
    "4 - 1 km but less than 2 km",
    "5 - 2 km but less than 4 km (1 nm but less than 2 nm)",
    "6 - 4 km but less than 10 km (2 nm but less than 5 nm)",
    "7 - 10 km but less than 20 km (5 nm but less than 11 nm)",
    "8 - 20 km but less than 50 km (11 nm but less than 27 nm)",
    "9 - 50 km or greater (27 nm or greater)",
  ];

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <br />
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                onChange={onChangeDateTime}
                style={{ width: "100%" }}
              />
              {errors.log_date_time && (
                <ShowInputError errorMessage={errors.log_date_time} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>vessel status</label>
              <Select
                value={vessel_status}
                placeholder=" -- Select of  vessel status  -- "
                style={{ width: "100%" }}
                onChange={(value) => set_vessel_status(value)}
              >
                <Select.Option value="At Sea">At Sea</Select.Option>
                <Select.Option value="At Anchor">At Anchor</Select.Option>
                <Select.Option value="At Port">At Port</Select.Option>
              </Select>
              {errors.vessel_status && (
                <ShowInputError errorMessage={errors.vessel_status} />
              )}
            </div>
          </div>
        </div>
        <h3>Weather Details </h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Sea Condition</label>
              <Select
                disabled={submitStatus}
                value={sea_condition}
                placeholder=" -- Select of  Sea Condition  -- "
                style={{ width: "100%" }}
                onChange={(value) => set_sea_condition(value)}
              >
                {weather_details?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
              {errors.sea_condition && (
                <ShowInputError errorMessage={errors.sea_condition} />
              )}
            </div>
          </div>
          {/* Wind Condition */}
          <div className="col-6">
            <div className="input-box">
              <label>Wind Force</label>
              <Select
                placeholder="--select of Wind Force --"
                style={{ width: "100%" }}
                disabled={submitStatus}
                value={wind_condition}
                onChange={(value) => set_wind_condition(value)}
              >
                {wind_conditions?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
              {errors.wind_condition && (
                <ShowInputError errorMessage={errors.wind_condition} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          {/* Swell */}
          <div className="col-6">
            <div className="input-box">
              <label>Swell Height (In meters)</label>
              <Input
                disabled={submitStatus}
                value={swell}
                placeholder="Swell Height"
                onChange={(e) => set_swell(e.target.value)}
              />
              {errors.swell && <ShowInputError errorMessage={errors.swell} />}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Swell Direction</label>
              <Input
                value={swell_direction}
                placeholder="Swell Direction"
                onChange={(e) => set_swell_direction(e.target.value)}
              />
              {errors.swell_direction && (
                <ShowInputError errorMessage={errors.swell_direction} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Visibility</label>
              <Select
                placeholder="--select of Visibility --"
                style={{ width: "100%" }}
                value={visibility}
                onChange={(value) => set_visibility(value)}
              >
                {visibility_Data?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
              {errors.visibility && (
                <ShowInputError errorMessage={errors.visibility} />
              )}
            </div>
          </div>
        </div>
        <br />
        <h3>Position (GPS & other)</h3>
        <div className="row">
          {/* Latitude */}
          <div className="col-6">
            <div className="input-box">
              <label>Latitude</label>
              <Input
                disabled={submitStatus}
                value={position_in_latitude}
                placeholder="Latitude"
                onChange={(e) => set_position_in_latitude(e.target.value)}
              />
              {errors.latitude && (
                <ShowInputError errorMessage={errors.latitude} />
              )}
            </div>
          </div>
          {/* Longitude */}
          <div className="col-6">
            <div className="input-box">
              <label>Longitude</label>
              <Input
                disabled={submitStatus}
                value={position_in_longitude}
                placeholder="Longitude"
                onChange={(e) => set_position_in_longitude(e.target.value)}
              />
              {errors.longitude && (
                <ShowInputError errorMessage={errors.longitude} />
              )}
            </div>
          </div>
        </div>
        <br />

        <h3>Speed</h3>
        <div className="row">
          {/* Speed or Gps */}
          <div className="col-6">
            <div className="input-box">
              <label>Speed through GPS (In knots)</label>
              <Input
                disabled={submitStatus}
                value={speed}
                placeholder="Speed through GPS"
                onChange={(e) => set_speed(e.target.value)}
              />
              {errors.speed_gps && (
                <ShowInputError errorMessage={errors.speed_gps} />
              )}
            </div>
          </div>
          {/* on Ground */}
          <div className="col-6">
            <div className="input-box">
              <label>Speed through Water (In knots)</label>
              <Input
                disabled={submitStatus}
                value={speed_on_ground}
                placeholder="Speed through Water"
                onChange={(e) => set_speed_on_ground(e.target.value)}
              />
              {errors.speed_through_water && (
                <ShowInputError errorMessage={errors.speed_through_water} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          {/* distance Covered  */}
          <div className="col-6">
            <div className="input-box">
              <label>Distance Covered (In nautical miles)</label>
              <Input
                disabled={submitStatus}
                value={distance_covered}
                placeholder="Distance Covered"
                onChange={(e) => set_distance_covered(e.target.value)}
              />
              {errors.distance_covered && (
                <ShowInputError errorMessage={errors.distance_covered} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Distance to go (In nautical miles)</label>
              <Input
                disabled={submitStatus}
                value={distance_to_go}
                placeholder="Distance To Go"
                onChange={(e) => set_Distance_To_Go(e.target.value)}
              />
              {errors.distance_to_go && (
                <ShowInputError errorMessage={errors.distance_to_go} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Course/Heading (In degrees)</label>
              <Input
                disabled={submitStatus}
                value={course_heading}
                placeholder="Course/Heading"
                onChange={(e) => set_course_heading(e.target.value)}
              />
              {errors.course && <ShowInputError errorMessage={errors.course} />}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Hours Underway</label>
              <Input
                value={hours_Underway}
                placeholder="Hours Underway"
                onChange={(e) => set_Hours_Underway(e.target.value)}
              />
              {errors.hours_underway && (
                <ShowInputError errorMessage={errors.hours_underway} />
              )}
            </div>
          </div>
        </div>

        <br />
        <h3>Voyage Details</h3>
        <div className="row">
          {/* Loaded/ Ballast  */}
          <div className="col-6">
            <div className="input-box">
              <label>Loaded/ Ballast</label>
              <Input
                disabled={submitStatus}
                value={loaded_ballast}
                placeholder="Loaded/ Ballast"
                onChange={(e) => set_loaded_ballast(e.target.value)}
              />
              {errors.loaded_ballast && (
                <ShowInputError errorMessage={errors.loaded_ballast} />
              )}
            </div>
          </div>
          {/* Draft */}
          <div className="col-6">
            <div className="input-box">
              <label>Draft (In meter)</label>
              <Input
                disabled={submitStatus}
                value={draft}
                placeholder="Draft"
                onChange={(e) => set_draft(e.target.value)}
              />
              {errors.draft && <ShowInputError errorMessage={errors.draft} />}
            </div>
          </div>
        </div>
        <div className="row">
          {/* Qty of cargo  */}
          <div className="col-6">
            <div className="input-box">
              <label>Quantity of Cargo</label>
              <Input
                disabled={submitStatus}
                value={voyage_qty_of_cargo}
                placeholder="Quantity of Cargo"
                onChange={(e) => set_voyage_qty_of_cargo(e.target.value)}
              />
              {errors.qty_of_cargo && (
                <ShowInputError errorMessage={errors.qty_of_cargo} />
              )}
            </div>
          </div>
          {/* qty of bllast */}
          <div className="col-6">
            <div className="input-box">
              <label>Quantity of Ballast</label>
              <Input
                disabled={submitStatus}
                value={qty_of_ballast}
                placeholder="Quantity of Ballast"
                onChange={(e) => set_qty_of_ballast(e.target.value)}
              />
              {errors.qty_of_ballast && (
                <ShowInputError errorMessage={errors.qty_of_ballast} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          {/* Port From */}
          <div className="col-6">
            <div className="input-box">
              <label>Port From</label>
              <Input
                disabled={submitStatus}
                value={port_from}
                placeholder="Port From"
                onChange={(e) => set_port_from(e.target.value)}
              />
              {errors.port_from && (
                <ShowInputError errorMessage={errors.port_from} />
              )}
            </div>
          </div>
          {/* Port To */}
          <div className="col-6">
            <div className="input-box">
              <label>Port To</label>
              <Input
                disabled={submitStatus}
                value={port_to}
                placeholder="Port To"
                onChange={(e) => set_port_to(e.target.value)}
              />
              {errors.port_to && (
                <ShowInputError errorMessage={errors.port_to} />
              )}
            </div>
          </div>
        </div>

        <h3>Charterer Details</h3>
        <div className="row">
          {/* Instructed Speed? */}
          <div className="col-6">
            <div className="input-box">
              <label>Instructed Speed</label>
              <Input
                disabled={submitStatus}
                value={instructed_speed}
                placeholder="Instructed Speed"
                onChange={(e) => set_instructed_speed(e.target.value)}
              />
              {errors.speed_gps && (
                <ShowInputError errorMessage={errors.speed_gps} />
              )}
            </div>
          </div>
        </div>
        <h3>Fuel ROB</h3>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>HSFO ROB</label>
              <Input
                disabled={submitStatus}
                value={hsfo_consumption}
                placeholder="HSFO fuel Consumption"
                onChange={(e) => set_hsfo_consumption(e.target.value)}
              />
              {errors.hsfo_consumption && (
                <ShowInputError errorMessage={errors.hsfo_consumption} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>VLSFO ROB</label>
              <Input
                disabled={submitStatus}
                value={vlsfo_consumption}
                placeholder="VLSFO fuel Consumption"
                onChange={(e) => set_vlsfo_consumption(e.target.value)}
              />
              {errors.vlsfo_consumption && (
                <ShowInputError errorMessage={errors.vlsfo_consumption} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>LO ROB</label>
              <Input
                value={lo_consumption}
                placeholder="LO fuel Consumption"
                onChange={(e) => set_lo_consumption(e.target.value)}
              />
              {errors.lube_orb && (
                <ShowInputError errorMessage={errors.lube_orb} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>FW ROB</label>
              <Input
                value={fw_consumption}
                placeholder="VLSFO fw Consumption"
                onChange={(e) => set_fw_consumption(e.target.value)}
              />
              {errors.fw_rob && <ShowInputError errorMessage={errors.fw_rob} />}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>LSMGO ROB</label>
              <Input
                disabled={submitStatus}
                value={lsmgo_consumption}
                placeholder="LSMGO fuel Consumption"
                onChange={(e) => set_lsmgo_consumption(e.target.value)}
              />
              {errors.lsmgo_consumption && (
                <ShowInputError errorMessage={errors.lsmgo_consumption} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>OTHER ORB</label>
              <Input
                disabled={submitStatus}
                value={other_consumption}
                placeholder="Other fuel Consumption"
                onChange={(e) => set_other_consumption(e.target.value)}
              />
              {errors.other_consumption && (
                <ShowInputError errorMessage={errors.other_consumption} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Deck Logbook Comments</label>
              <TextArea
                rows={6}
                placeholder="Deck Logbook Comments"
                maxLength={1000}
                disabled={submitStatus}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
              {errors.deck_comment && (
                <ShowInputError errorMessage={errors.deck_comment} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          {

          user?.data?.designation === "Captain" ?
          <div className="input-box" style={{ marginTop: "15px" }}>
              <Button
                disabled={submitStatus}
                loading={loader}
                className="save_btn"
                style={{ color: "white" }}
                onClick={() => Edit_DECK_LOGBOOK_APIS("1")}
              >
                Submit
              </Button>
            </div>:
            <div className="input-box" style={{ marginTop: "15px" }}>
            <Button
              disabled={submitStatus}
              loading={loader}
              type="primary"
              className="save_btn"
              style={{ color: "white", marginLeft: "10px" }}
              onClick={Edit_DECK_LOGBOOK_APIS}
              // onClick={handleSubmit}
            >
              Save
            </Button>
          </div>
          }
          {/* {
            (user?.data?.designation === "Captain" && id) && (
            <div className="input-box" style={{ marginTop: "15px" }}>
              <Button
                disabled={submitStatus}
                loading={loader}
                className="save_btn"
                style={{ color: "white" }}
                onClick={() => Edit_DECK_LOGBOOK_APIS("1")}
              >
                Submit
              </Button>
            </div>
          )}
          <div className="input-box" style={{ marginTop: "15px" }}>
            <Button
              disabled={submitStatus}
              loading={loader}
              type="primary"
              className="save_btn"
              style={{ color: "white", marginLeft: "10px" }}
              onClick={Edit_DECK_LOGBOOK_APIS}
              // onClick={handleSubmit}
            >
              Save
            </Button>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default EditDeckLog;
